module.exports = __webpack_public_path__ + "media/crypto/opaig-5b129921.png";